module.exports = __webpack_public_path__ + "static/media/earth-icon.119ba3d7.png";